<!--
// app/components/Shared/players/DoubleMvpChip.vue
-->
<script setup lang="ts">
import type { SeasonStatsPartner } from "#shared/season-cluster/domain/models/01.Season";

type Props = {
  totalMvp: number | string;
  totalMvpT: number | string;
  mvpPartner?: SeasonStatsPartner;
};

defineProps<Props>();
</script>

<template>
  <div class="container-mvp-info">
    <div class="stats-data-container-mvp">
      <div class="absolute -top-1.5 text-center md:static">
        <img v-if="mvpPartner" :src="mvpPartner.logo" :alt="mvpPartner.name" class="h-3.5 md:h-4" />
      </div>
      <div class="mvp-data-container">
        <span class="text-secondary text-xs">{{ $t("players.card.turnMvp.title") }}</span>
        <span class="font-bold">{{ totalMvpT }}</span>
      </div>
      <div class="mvp-data-container">
        <span class="text-secondary text-xs">{{ $t("players.card.mvp.title") }}</span>
        <span class="font-bold">{{ totalMvp }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.stats-data-container-mvp {
  @apply rounded-lg bg-gray-800 flex flex-wrap flex-col md:flex-row md:items-center justify-start gap-1 md:gap-2;
  @apply md:max-w-max py-2.5 px-3 md:px-2 md:py-1 relative;
}

.mvp-data-container {
  @apply flex gap-x-1 items-center;
}
</style>
